import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import Row from "../../../smartsetter-utils/common/components/Row"
import { PAGE_SIZE_OPTIONS, coercePageSize } from "./pageSizePreference"

export default function PageSizeSelector({ pageSize, onPageSizeChange }) {
  const selectedSize = coercePageSize(pageSize) ?? PAGE_SIZE_OPTIONS[1]

  return (
    <Row sx={{ alignItems: "center", gap: 1 }}>
      <Text>Show:</Text>
      <Select
        value={selectedSize}
        onChange={(e) => onPageSizeChange(e.target.value)}
        size="small"
        sx={{ minWidth: 70 }}
      >
        {PAGE_SIZE_OPTIONS.map((size) => (
          <MenuItem key={size} value={size}>
            {size}
          </MenuItem>
        ))}
      </Select>
      <Text>per page</Text>
    </Row>
  )
}

const Text = styled((props) => <Typography variant="body2" {...props} />)(
  ({ theme }) => ({
    color: "text.secondary",
    [theme.breakpoints.only("xs")]: {
      display: "none",
    },
  })
)
